export const APP_HOST = process.env.VUE_APP_HOST;
export const APP_DOCTIS = process.env.VUE_APP_DOCTIS;
export const APP_DOCTIS_API_KEY = process.env.VUE_APP_DOCTIS_API_KEY;
export const APP_DOCTIS_FILE_SERVER_URL = process.env.VUE_APP_DOCTIS_FILE_SERVER_URL;
export const APP_PATIENT_URL = process.env.VUE_APP_PATIENT_URL;
export const APP_DOCTOR_URL = process.env.VUE_APP_DOCTOR_URL;
export const APP_ANALYSIS_API_URL = process.env.VUE_APP_ANALYSIS_API_URL;
export const APP_ANALYSIS_API_TOKEN = process.env.VUE_APP_ANALYSIS_API_TOKEN;
export const APP_SETTINGS = process.env.VUE_APP_SETTINGS;
export const APP_SENTRY_DSN = process.env.VUE_APP_SENTRY_DSN;
export const APP_AICHAT_URL = process.env.VUE_APP_AICHAT_URL;
export const APP_REMOTE_MONITORING_SERVICE_URL = process.env?.VUE_APP_REMOTE_MONITORING_SERVICE_URL;
export const APP_REMOTE_MONITORING_SERVICE_LOCAL_URL = process.env?.VUE_APP_REMOTE_MONITORING_SERVICE_LOCAL_URL;
export const APP_REMOTE_MONITORING_SERVICE_CSS_LOCAL_URL = process.env?.VUE_APP_REMOTE_MONITORING_SERVICE_CSS_LOCAL_URL;
export const APP_USE_LOCAL_REMOTE_MONITORING_SERVICE = process.env?.VUE_APP_USE_LOCAL_REMOTE_MONITORING_SERVICE;
export const APP_USE_SENTRY = process.env?.VUE_APP_USE_SENTRY;

export default {
  APP_HOST,
  APP_DOCTIS,
  APP_DOCTIS_API_KEY,
  APP_PATIENT_URL,
  APP_DOCTOR_URL,
  APP_ANALYSIS_API_URL,
  APP_ANALYSIS_API_TOKEN,
  APP_SETTINGS,
  APP_SENTRY_DSN,
  APP_AICHAT_URL,
  APP_REMOTE_MONITORING_SERVICE_URL,
  APP_REMOTE_MONITORING_SERVICE_LOCAL_URL,
  APP_REMOTE_MONITORING_SERVICE_CSS_LOCAL_URL,
  APP_USE_LOCAL_REMOTE_MONITORING_SERVICE,
  APP_USE_SENTRY,
};
